import React from 'react';
import { useDocumentImportProgressDialogStyles } from './component.style';

export const DocumentImportProgressDialog = () => {
  const classes = useDocumentImportProgressDialogStyles();
  return <div className={classes.container} />;
};
